import { render } from "./Dashboard2.vue?vue&type=template&id=42b5cdbc&scoped=true"
import script from "./Dashboard2.vue?vue&type=script&lang=js"
export * from "./Dashboard2.vue?vue&type=script&lang=js"

import "./Dashboard2.vue?vue&type=style&index=0&id=42b5cdbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b5cdbc"]])

export default __exports__